import { useEffect, useState } from 'react';

import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './Efficiency.styles';

interface EfficiencyItem {
  id: number;
  src: string;
  srcReverse?: string;
  srcSet?: string;
  alt?: string;
  type: 'image' | 'video';
}

const efficiencyImages: EfficiencyItem[] = [
  {
    id: 1,
    src: staticMediaUrl('landing/bioderma_sebium/efficiency1.jpg'),
    alt: 'Эффективность продукта 1',
    type: 'image'
  },
  {
    id: 2,
    src: staticMediaUrl('landing/bioderma_sebium/efficiency2_1.png'),
    srcReverse: staticMediaUrl(
      'landing/bioderma_sebium/efficiency2_2_reverse.png'
    ),
    alt: 'Эффективность продукта 2',
    type: 'image'
  },
  {
    id: 3,
    src: staticMediaUrl('landing/bioderma_sebium/efficiency3.mp4'),
    type: 'video'
  },
  {
    id: 4,
    src: staticMediaUrl('landing/bioderma_sebium/efficiency4_1.png?1'),
    srcReverse: staticMediaUrl(
      'landing/bioderma_sebium/efficiency4_2_reverse.png?1'
    ),
    alt: 'Эффективность продукта 2',
    type: 'image'
  },
  {
    id: 5,
    src: staticMediaUrl('landing/bioderma_sebium/efficiency4.mp4'),
    type: 'video'
  }
];

type CardSide = 'front' | 'back';

export function Efficiency() {
  const slots = styles();

  const [cardSide, setCardSide] = useState<Record<number, CardSide>>(() =>
    efficiencyImages.reduce<Record<number, CardSide>>((acc, item) => {
      acc[item.id] = 'front';
      return acc;
    }, {})
  );

  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    efficiencyImages.forEach((item) => {
      if (item.type === 'image') {
        const img1 = new Image();
        img1.src = item.src;

        if (item.srcReverse) {
          const img2 = new Image();
          img2.src = item.srcReverse;
        }
      }
    });
  }, []);

  useEffect(() => {
    if (isHovered) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setCardSide((prev) => {
        const next = { ...prev };

        efficiencyImages.forEach((item) => {
          if (!item.srcReverse) {
            return;
          }

          next[item.id] = prev[item.id] === 'front' ? 'back' : 'front';
        });

        return next;
      });
    }, 3000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [isHovered]);

  const handleMouseEnter = (hasReverse: boolean) => {
    if (!hasReverse) {
      return;
    }

    setIsHovered(true);
  };

  const handleMouseLeave = (hasReverse: boolean) => {
    if (!hasReverse) {
      return;
    }

    setIsHovered(false);
  };

  const handleClick = (id: number, hasReverse: boolean) => {
    if (!hasReverse) {
      return;
    }

    setCardSide((prev) => ({
      ...prev,
      [id]: prev[id] === 'front' ? 'back' : 'front'
    }));
  };

  return (
    <div
      className={slots.base()}
      id="efficiency"
    >
      <UiKitCarouselBase
        className="[--slide-spacing:12px]"
        arrowPrevClass={slots.arrowPrev()}
        arrowNextClass={slots.arrowNext()}
        loop={false}
        alwaysShowArrows
      >
        {efficiencyImages.map((item) => {
          const side = cardSide[item.id] ?? 'front';
          const isFlippable = Boolean(item.srcReverse);
          const currentSrc =
            side === 'back' && item.srcReverse ? item.srcReverse : item.src;
          const shouldFlip = side === 'back' && item.srcReverse;

          return (
            <div
              key={item.id}
              className={`${slots.item()} ${isFlippable ? 'cursor-pointer' : ''}`}
              onMouseEnter={() => handleMouseEnter(isFlippable)}
              onMouseLeave={() => handleMouseLeave(isFlippable)}
              onClick={() => handleClick(item.id, isFlippable)}
            >
              {item.type === 'image' ? (
                <img
                  className={shouldFlip ? slots.imageFlipped() : slots.image()}
                  src={currentSrc}
                  alt={item.alt ?? ''}
                />
              ) : (
                <video
                  className={slots.image()}
                  src={item.src}
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              )}
            </div>
          );
        })}
      </UiKitCarouselBase>
    </div>
  );
}
